import React from "react";
import { Heart, ShieldCheck, Award, BadgeCheck, ExternalLink } from "lucide-react";
import { LicenseLink } from "../LicenseLink";

export const TrustPillars = ({ t }) => {
  const pillars = [
    { id: "family", icon: Heart, label: t.trust.stat2Label, value: t.trust.stat2Value },
    { id: "years", icon: Award, label: t.trust.stat1Label, value: t.trust.stat1Value },
    { id: "integrity", icon: ShieldCheck, label: t.trust.stat3Label, value: t.trust.stat3Value },
  ];
  return (
    <div className="mt-10 grid grid-cols-1 sm:grid-cols-3 gap-px bg-brand-border border border-brand">
      {pillars.map((p, i) => (
        <div key={p.id} data-testid={`trust-pillar-${i}`} className="bg-white p-5 md:p-6 flex flex-col gap-2">
          <p.icon className="w-6 h-6 text-brand-accent" strokeWidth={2} />
          <div className="font-display font-black text-2xl md:text-3xl text-brand-primary tracking-tight">
            {p.value}
          </div>
          <div className="font-display font-semibold text-xs uppercase tracking-wider text-brand-muted">
            {p.label}
          </div>
        </div>
      ))}
    </div>
  );
};

export const LicenseCard = ({ t }) => (
  <LicenseLink
    t={t}
    testId="about-license"
    className="mt-6 inline-flex items-center gap-3 border border-brand bg-white px-4 py-3 hover:border-brand-accent hover:shadow-md transition-all group"
  >
    <BadgeCheck className="w-5 h-5 text-brand-accent" strokeWidth={2} />
    <div className="leading-tight">
      <div className="font-display font-semibold text-[11px] uppercase tracking-wider text-brand-muted">
        {t.trust.licenseLabel}
      </div>
      <div className="font-display font-black text-base text-brand-primary tracking-tight">#1162340</div>
    </div>
    <span className="ml-2 inline-flex items-center gap-1 font-display font-bold text-xs text-brand-accent group-hover:underline">
      {t.trust.licenseVerifyCta}
      <ExternalLink className="w-3.5 h-3.5" strokeWidth={2.5} />
    </span>
  </LicenseLink>
);
